import { SelectionMenuConfig } from '../../../components/ButtonBaseWithSelectionMenu/types/buttonBaseWithSelectionMenu.types';

export const ORDER_PRODUCT_SELECTION_MENU_CONFIG: SelectionMenuConfig = {
  maxWidth: 420,
  maxHeight: 320,
  hasSearch: true,
};
